import { render, staticRenderFns } from "./AVAXBalanceTableDetail.vue?vue&type=template&id=e3d56a26&scoped=true&"
import script from "./AVAXBalanceTableDetail.vue?vue&type=script&lang=ts&"
export * from "./AVAXBalanceTableDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AVAXBalanceTableDetail.vue?vue&type=style&index=0&id=e3d56a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d56a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
